// Constants
// Actions
import { ViewDataFetchAction, ViewForceDataFetchAction } from "@ms/planner-actions/lib/local/viewLifecycle/ViewLifecycleAction";
export class ViewLifecycleModule {
    setViewDataFetchState(viewDetails, state, extraData) {
        this.dispatcher.dispatchActionAsync(new ViewDataFetchAction(viewDetails, state, extraData));
    }
    setViewForceFetchDataState(viewDetails, shouldForceFetch) {
        this.dispatcher.dispatchActionAsync(new ViewForceDataFetchAction(viewDetails, shouldForceFetch));
    }
    constructor(dispatcher){
        this.dispatcher = dispatcher;
    }
}
